import { combineReducers } from "redux";
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// Authentication
import authReducer from "./auth/reducer";
import playerReducer from "./player/reducer";
import layoutReducer from "./layout/reducer";
import chatReducer from "./chat/reducer";

const authPersistConfig = {
  key: 'auth',
  storage: storage
}

const playerPersistConfig = {
  key: 'player',
  storage: storage
}

const layoutPersistConfig = {
  key: 'layout',
  storage: storage
}

const chatPersistConfig = {
  key: 'chat',
  storage: storage
}


const rootReducer = combineReducers({
	Auth: persistReducer(authPersistConfig, authReducer),
  
	Player: persistReducer(playerPersistConfig, playerReducer),
  
	Layout: persistReducer(layoutPersistConfig, layoutReducer),
  
	Chat: persistReducer(chatPersistConfig, chatReducer),
});

export default rootReducer;
